import React from "react";
import { Carousel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IAdsHomeItem } from "../../../../business";

export const CarouselHero: React.FC<{ items: Array<IAdsHomeItem> }> = ({ items }) => {
    const navigate = useNavigate();
    return (
        <Carousel style={{ marginTop: "20px" }}>
            {items.map((item, index) => (
                <Carousel.Item key={index}>
                    <div onClick={() => navigate(`product/${item.url}`)}>
                        <img className="d-block w-100" src={item.image} alt={item.description} height={503} />
                    </div>
                    {item.showDescription ?
                        <Carousel.Caption>
                            <h3>{item.description}</h3>
                        </Carousel.Caption>
                        : <></>}
                </Carousel.Item>
            ))}
        </Carousel>
    );
}
